module.exports = __webpack_public_path__ + "95404a87dc91fb18bfebaccfda634b32.svg";